import {ssrLazy} from 'ssr/lazy';

export const TextWithVideoLazy = ssrLazy(() => import(/* webpackChunkName: "textWithVideo" */ '.'));
